export default "__VITE_ASSET__hPWoLO04__"